import React, { useEffect } from "react";
import { fetchProfile } from "@/app/actions/general";
import { FlatList } from "react-native";
import { settingsStyles as styles } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import Header from "./Header";
import OrderHistory from "./OrderHistory";
import {
  getPastOrders,
  getOrdersLoading,
  getHasMoreOrders,
} from "@/app/selectors/order";
import { doFetchOrders } from "@/app/actions/order";

type SettingsProps = {
  onLogoutPress: () => void;
};

const Settings = ({ onLogoutPress }: SettingsProps) => {
  const dispatch = useDispatch();
  const pastOrders = useSelector(getPastOrders);
  const ordersLoading = useSelector(getOrdersLoading);
  const hasMore = useSelector(getHasMoreOrders);

  useEffect(() => {
    dispatch(fetchProfile());
    dispatch(doFetchOrders(false));
  }, [dispatch]);

  const loadNextPage = () => {
    if (ordersLoading) return;
    if (!hasMore) return;

    dispatch(doFetchOrders(true));
  };

  return (
    <FlatList
      data={pastOrders}
      renderItem={({ item }) => <OrderHistory order={item} />}
      numColumns={3}
      ListHeaderComponentStyle={styles.listHeader}
      ListHeaderComponent={<Header onLogoutPress={onLogoutPress} />}
      onEndReached={loadNextPage}
    />
  );
};

export default Settings;
